import { Box, Typography } from '@mui/material';
const SatelliteDataReportSubHeader = ({ text }) => {
  return (
    <Box
      sx={{
        bgcolor: '#237D41CC',
        color: 'white',
        p: 1,
        '@media print': {
          padding: '1.5mm',
          backgroundColor: '#237D41CC !important',
          color: 'white !important',
          pageBreakInside: 'avoid',
        },
      }}
    >
      <Typography
        sx={{
          '@media print': {
            fontSize: '3.5mm',
          },
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default SatelliteDataReportSubHeader;
